import React, {useContext} from 'react'
import  UserContext  from '../../context/Globales/UserContext';

import { makeStyles, useTheme } from "@material-ui/core/styles";
import {Grid, Paper }from '@material-ui/core';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";

import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";





const useStyles = makeStyles((theme) => ({

  titulo: {
  backgroundColor: theme.palette.fondotitulos.main, 
  minWidth: 200,
  color: 'dark',
  },
  table: {
    backgroundColor: theme.palette.greyFondo.main, 

  },
  alert:{
    backgroundColor: theme.palette.alerta.main
  },
  containerTable: {
    maxHeight: 540,
    maxWidth: '100%'
  },
  column: {
    backgroundColor: theme.palette.fondotitulos.main,
    textAlign: 'center',
    color: 'dark'
  },

  titulotabla: {
    backgroundColor: theme.palette.fondotitulos.main, 
    
     
    color: 'dark',
  
    },

}));






const DataTableDetalle = () => {

    const { DataDetalle } = useContext(UserContext);

//    console.log(DataDetalle)

 //   console.log(DataDetalle.detalles)

    const classes = useStyles();

    return (  

        <>  
        {DataDetalle && DataDetalle.detalles !== null ? 
            <Grid
            container
            justify="center"       
            >
                <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                <TableContainer component={Paper} elevation={3} className={classes.containerTable} >
          <div style={{textAlign: 'center', padding: '20px', fontWeight: 'bold'}} className={classes.titulo}>Consulta Usuario  </div>      
      <Table className={classes.table} stickyHeader aria-label="sticky table" size="small"  >            
        <TableHead >
              <TableRow >
              <TableCell style={{textAlign: 'justify', paddingLeft: '140px', width: '5%'}} className={classes.titulotabla} >
                   #        
             </TableCell> 
              <TableCell style={{textAlign: 'justify', paddingLeft: '140px', width: '40%'}} className={classes.titulotabla} >
                   Fecha Consulta        
             </TableCell> 
             
             <TableCell sstyle={{width: '880px', textAlign: 'left' }} className={classes.titulotabla} >
                     Consulta Rut      
             </TableCell>
             <TableCell sstyle={{width: '880px', textAlign: 'left' }} className={classes.titulotabla} >
                     Tipo Consulta      
             </TableCell>

              </TableRow>
        </TableHead>
          <TableBody>
            {/* si aqui no mapea, tengo que agregarle el ? despues del Morosidades*/}
            {DataDetalle.detalles?.map((item, id)=>(
            
            <TableRow hover key={id}> 
                <TableCell style={{textAlign: 'justify', paddingLeft: '140px', width: '5%'}} className={ item.Valor > 0 && classes.alert} >
             {id + 1}              
            </TableCell> 
            <TableCell style={{textAlign: 'justify', paddingLeft: '140px', width: '40%'}} className={ item.Valor > 0 && classes.alert} >
             {item.FechaConsulta}              
            </TableCell> 
            {/*<TableCell style={{textAlign: 'center'}} className={ item.Valor > 0 && classes.alert}  >
             :              
            </TableCell> */}

            <TableCell style={{width: '880px', textAlign: 'left' ,  fontWeight: 'bold'}} className={ item.Valor > 0 && classes.alert} >
             {item.RutConsulta}             
            </TableCell> 
            <TableCell style={{width: '880px', textAlign: 'left' ,  fontWeight: 'bold'}} className={ item.Valor > 0 && classes.alert} >
             {item.TipoConsulta}             
            </TableCell> 
             </TableRow>
             ))}                  
          </TableBody>
      </Table>
    </TableContainer>
    </Grid>
    </Grid>
    : <h2>Cargando información espere...</h2> }
        </>
    );
}
 
export default DataTableDetalle;